import { useSuspenseQuery } from '@tanstack/react-query';

import { RobotTemplateManager, RobotTemplateUrls } from './RobotTemplateManager';

export function useAllRobotTemplates() {
  const { data } = useSuspenseQuery({
    queryKey: [RobotTemplateUrls.GetAllRobotTemplates],
    queryFn: () => RobotTemplateManager.GetAllRobotTemplates(),
  });

  return data;
}
